import React from "react"
import PropTypes from "prop-types"
import { Box, Flex, Link, chakra } from "@chakra-ui/react"
import { Link as GatsbyLink } from "gatsby"
import DesktopMenu from "./desktop-menu"
import MobileMenu, { MobileMenuToggle, useMobileMenu } from "./mobile-menu"
import { medium, compact, mobile } from "./menu"
import logo from "../../images/logos/header-logo.svg"

const styles = {
  header: {
    bg: "white",
    boxShadow: "0 1px 0 rgba(16, 24, 40, 0.06)",
  },
  sticky: {
    position: "sticky",
    top: 0,
    zIndex: "sticky",
  },
  bar: {
    height: "94px",
    px: "24px",
    justifyContent: "space-between",
    alignItems: "center",
    [compact]: { px: "18px" },
    [mobile]: { height: "76px" },
    "@media (max-width: 600px)": { height: "68px", px: "16px" },
  },
  logo: {
    display: "block",
    flex: "0 0 auto",
    lineHeight: 0,
  },
  "logo-image": {
    display: "block",
    width: "190px",
    height: "auto",
    [medium]: { width: "160px" },
    [compact]: { width: "140px" },
    "@media (max-width: 600px)": { width: "132px" },
  },
}

const Navigation = ({ hideMenu, sticky }) => {
  const { ref, isOpen, onToggle } = useMobileMenu()

  return (
    <Box
      as="header"
      ref={ref}
      sx={sticky ? { ...styles.header, ...styles.sticky } : styles.header}
    >
      <Flex as="nav" aria-label="Main" sx={styles.bar}>
        <Link as={GatsbyLink} to="/" sx={styles.logo}>
          <chakra.img
            src={logo}
            alt="Avant-garde Health logo"
            sx={styles["logo-image"]}
          />
        </Link>
        {!hideMenu && <DesktopMenu />}
        {!hideMenu && <MobileMenuToggle isOpen={isOpen} onToggle={onToggle} />}
      </Flex>
      {!hideMenu && <MobileMenu isOpen={isOpen} />}
    </Box>
  )
}

Navigation.propTypes = {
  hideMenu: PropTypes.bool,
  sticky: PropTypes.bool,
}

Navigation.defaultProps = {
  sticky: true,
}

export default Navigation
